"use client";

import { Moon, Sun } from "lucide-react";
import { useSyncExternalStore } from "react";

// =============================================================================

const FORMATTER = new Intl.DateTimeFormat("fr-FR", {
  timeZone: "Europe/Paris",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

function subscribe(onChange: () => void) {
  const timer = window.setInterval(onChange, 10_000);
  return () => window.clearInterval(timer);
}

const getTime = () => FORMATTER.format(Date.now());

/**
 * Live time in Paris (rendered in the browser only: the server does not know
 * when the page is read), with a sun or a moon.
 */
export function ParisClock({
  labels,
}: {
  labels: { day: string; night: string };
}) {
  const time = useSyncExternalStore(subscribe, getTime, () => null);
  const [hours, minutes] = (time ?? "--:--").split(":");
  const isDay = time !== null && Number(hours) >= 7 && Number(hours) < 20;
  const Icon = isDay ? Sun : Moon;

  return (
    <div className="flex items-end justify-between gap-4">
      <time
        dateTime={time ?? undefined}
        className="text-[clamp(2.75rem,4.2vw,4rem)] leading-none font-extrabold tracking-[-0.04em] tabular-nums"
      >
        {hours}
        <span className="motion-safe:animate-caret">:</span>
        {minutes}
      </time>
      {time !== null && (
        <Icon
          role="img"
          aria-label={isDay ? labels.day : labels.night}
          className="mb-1 size-6 text-brand"
        />
      )}
    </div>
  );
}

// =============================================================================
